import {
  USER_PROFILE_TAB_LOADING,
  USER_PROFILE_SUBSCRIPTION_DELETED,
  USER_PROFILE_DEVICES_UPDATED,
  USER_PROFILE_ON_CALL_STATUS,
  SET_QR_CODE_USE,
  DISABLE_MOBILE_LOGOUT,
  DISABLE_WEB_LOGOUT,
  DISABLE_AUTH_REVOKE,
} from 'actions/userProfilePage';

export const defaultState = {
  gwtTabLoading: false,
  refreshCounter: {
    devices: 0,
    subscriptions: 0,
  },
  onCallStatus: {},
  qrCodeUse: false,
  disableMobileLogout: false,
  disableWebLogout: false,
  disableAuthRevoke: true,
};

export default function userProfilePage(state = defaultState, action) {
  switch (action.type) {
    case USER_PROFILE_TAB_LOADING: {
      return {
        ...state,
        gwtTabLoading: action.payload,
      };
    }
    case USER_PROFILE_DEVICES_UPDATED: {
      return {
        ...state,
        refreshCounter: {
          ...state.refreshCounter,
          devices: state.refreshCounter.devices + 1,
        },
      };
    }
    case USER_PROFILE_SUBSCRIPTION_DELETED: {
      return {
        ...state,
        refreshCounter: {
          ...state.refreshCounter,
          subscriptions: state.refreshCounter.subscriptions + 1,
        },
      };
    }
    case USER_PROFILE_ON_CALL_STATUS: {
      const { status, userId } = action.payload;
      return {
        ...state,
        onCallStatus: {
          ...state.onCallStatus,
          [userId]: status,
        },
      };
    }
    case SET_QR_CODE_USE: {
      const qrCodeUse = action.payload;
      return {
        ...state,
        qrCodeUse,
      };
    }
    case DISABLE_MOBILE_LOGOUT: {
      const disableMobileLogout = action.payload;
      return {
        ...state,
        disableMobileLogout,
      };
    }
    case DISABLE_WEB_LOGOUT: {
      const disableWebLogout = action.payload;
      return {
        ...state,
        disableWebLogout,
      };
    }
    case DISABLE_AUTH_REVOKE: {
      const disableAuthRevoke = action.payload;
      return {
        ...state,
        disableAuthRevoke,
      };
    }
    default: {
      return state;
    }
  }
}
